import { Reducer } from "../../lib/redux";
import { OpenCabUserActions } from "./actions";
import { OpenCabUsersActionTypes } from "./types";

export let defaultOpenCabUsers: IIdDictionary<string> = {};

export let openCabUsers: Reducer<IIdDictionary<string>, OpenCabUserActions> = (state = defaultOpenCabUsers, action) => {
    switch (action.type) {
        case OpenCabUsersActionTypes.SET_OPENCABUSER: {
            if (action.payload) {
                return {
                    ...state,
                    [action.payload.internalUsername.toLowerCase()]: action.payload.externalUsername.toLowerCase()
                };
            }
            return state;
        }
        case OpenCabUsersActionTypes.CLEAR_OPENCABUSER: {
            if (action.payload) {
                let newState = { ...state };
                delete newState[action.payload];
                return newState;
            }
            return defaultOpenCabUsers;
        }
        default:
            return state;
    }
};
